import Vue from 'vue';
import Vuex from 'vuex';

import { search } from './search.module';
import { alert } from './alert.module';
import { authentication } from './authentication.module';
import { users } from './users.module';
import { orders } from './orders.module';
import { basket } from './basket.module';
import { fav } from './fav.module';
import { products } from './products.module';
import { projects } from './projects.module';

Vue.use(Vuex);

export const store = new Vuex.Store({
    modules: {
        search,
        alert,
        authentication,
        users,
        orders,
        basket,
        fav,
        products,
        projects,
    }
});